<template>
  <div class="payment-drawer-wrapper" :class="{ show: showDrawer === true }">
    <div
      style="
        width: 100%;
        height: 192px;
        background-color: #3dcf8e;
        left: 0px;
        top: 0px;
        position: absolute;
      "
    ></div>
    <v-img
      style="
        width: 274px;
        height: 292px;
        display: block;
        margin-left: auto;
        margin-right: auto;
      "
      :src="require('@/assets/images/checkout/fim-checkout.svg')"
    />
    <div
      style="
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-top: 50px;
        align-content: center;
        align-items: center;
      "
    >
      <p
        style="
          font-family: metropolismedium;
          font-weight: 700;
          font-size: 20px;
          line-height: 32px;
          color: #003036;
        "
      >
        Parabens! Você está a 1 passo de começar a compensar
      </p>
      <p
        style="
          margin-top: 16px;
          font-family: metropolisregular;
          text-align: center;
          width: 300px;
          font-weight: 400;
          font-size: 16px;
          color: #003036;
        "
      >
        Em breve, iremos entrar em contato para
        <b>validar a aplicação do selo na sua marca.</b>
      </p>
      <div
        style="
          cursor: pointer;
          margin-top: 32px;
          background-color: #26d07c;
          width: 157px;
          height: 43px;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          align-content: center;
          text-align: center;
          padding: 8px 48px;
          border-radius: 6px;
        "
        @click="closeDrawer"
      >
        <p
          style="
            font-family: metropolisbold;
            font-weight: 700;
            font-size: 18px;
            color: #003036;
            line-height: 27px;
            margin-top: 16px;
          "
        >
          FECHAR
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { mask } from 'vue-the-mask';

export default {
  name: 'SucessoDrawer',
  components: {},
  directives: { mask },
  props: {
    showDrawer: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(['checkout']),
    rules() {
      return {};
    },
  },
  watch: {
    showDrawer() {
      if (this.showDrawer === true) {
        document.querySelector('html').style.overflow = 'hidden';
      } else {
        document.querySelector('html').style.overflow = 'auto';
      }
    },
  },
  beforeMount() {},
  methods: {
    closeDrawer() {
      this.$emit('closeSucessoDrawer');
    },
  },
};
</script>

<style lang="sass" scoped>
@import '@/styles/util'
@import '@/styles/style'

#app
  &.new-color
    .v-btn
      border-radius: 6px
      font-family: "metropolisbold" !important
      font-weight: 700 !important
      font-size: 18px
      text-transform: initial
      letter-spacing: 0px
      box-shadow: none
      &.cancel-btn
        border: 1px solid #EF3340
        background: transparent !important
        color: #EF3340 !important
        margin-right: 30px !important
      &.pay-btn
        border: 1px solid #26D07C
        background: #26D07C !important
        color: #003036 !important

.payment-drawer-wrapper
  position: fixed
  top: 0
  left: 0
  background: #ffffff
  height: 100%
  width: 100%
  padding-top: 80px
  z-index: 100
  outline: 0
  transition: transform 500ms ease-in-out
  transform: translateX(-110%)
  overflow-y: auto
  &.show
    transform: none
    transition: transform 500ms ease-in-out
  .close-btn
    position: absolute
    display: block
    top: 4%
    right: 4%
    color: #003036
    font-size: 20px
    font-family: "metropolisbold"
    font-weight: normal
    outline: none
    text-decoration: none
    z-index: 100
  ::v-deep
    .v-radio
      flex-flow: row-reverse
      padding: 16px 24px 16px 16px
      background: #FFFFFF
      border-left: 8px solid #CDCDD0
      box-shadow: 0px 4px 8px rgb(7 8 23 / 16%)
      border-radius: 8px
      transition: all 300ms ease-in-out
      &.v-item--active
        border-left: 8px solid #26D07C
        transition: all 300ms ease-in-out
      .v-input--selection-controls__input
        margin-right: 0
      .v-label
        margin-right: 15px
        .v-icon
          margin-right: 10px

.wrapper
  ::v-deep
    .title
      text-align: left !important
      font-size: 2rem !important
      font-weight: 600 !important
      @media screen and (max-width: 959px)
        padding-left: 12px
    .title + .row
      justify-content: flex-start !important
      .separator
        width: 50%
        height: 4px
        margin-top: 10px
        @media screen and (max-width: 959px)
          width: 80%
          height: 2px
          margin-left: 12px
</style>
